import React, { useEffect } from 'react';
import { Layout } from '../../components/Layout/Layout';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export const CheckoutSuccess: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Automatically redirect to billing page after 5 seconds
    const timer = setTimeout(() => {
      navigate('/billing');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <div className="text-center">
          <CheckCircle className="mx-auto h-12 w-12 text-green-500" />
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
            Payment Successful!
          </h1>
          <p className="mt-4 text-base text-gray-500 dark:text-gray-400">
            Thank you for your subscription. You now have access to all AI services.
          </p>
          <div className="mt-6">
            <button
              onClick={() => navigate('/billing')}
              className="text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-500"
            >
              Return to Billing
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}; 